// Single source of truth for layout dimensions — imported by Navbar, Sidebar, Layout
export const SIDEBAR_WIDTH = 220;
export const TOPBAR_HEIGHT = 56;
